export default __webpack_public_path__ + "static/media/books-1920w.27f28306.webp";